export const API_URL_AUTH = process.env.VUE_APP_API_AUTH;
export const API_URL_SERVICE = process.env.VUE_APP_API_SERVICE;
export const BASE_PATH_APP = process.env.VUE_APP_BASE_PATH;
export const VERSION_APP = process.env.VUE_APP_VERSION;
export const ID_APP = process.env.VUE_APP_ID;
export const APP_NAME = process.env.VUE_APP_NAME;
